export const sharedEnvironment = {
	appName: 'Gymvio',
	productionUrl: 'https://gymvio.com',
	helpEmail: 'help@gymvio.com',
	contactEmailShownInFooter: 'contact[at]gymvio.com',
	refundEmail: 'refund@gymvio.com',
	primaryMenu: {
		desktop: {
			boxAId: 'boxDesktopA'
		}
	}
};
